export default __webpack_public_path__ + "static/media/techienest.84991f5b.png";